import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

const ELASTICSEARCH_URL = environment.baseElasticSearchUrl;

@Injectable({
    providedIn: 'root'
})

export class OwnerEvaluationService {
    private baseElasticSearchUrl = ELASTICSEARCH_URL;
    private getSponsorshipApplicationsAPI = "https://eh51w82ao9.execute-api.us-east-1.amazonaws.com/qa/sponsorship-properties";
    private getClientSponsorshipApplicationPerOwnerAPI = "https://eh51w82ao9.execute-api.us-east-1.amazonaws.com/qa/client-application-perOwner"; 

    constructor(private http: HttpClient) { }

    getApplications(body: any) {
        let headers = this.createReqHeader(); 
        return this.http.post<any>(this.getClientSponsorshipApplicationPerOwnerAPI, body, {headers: headers}); 
    }

    onEvaluationSearch(valuationQuery: any) {
        let headers = this.createReqHeader();    //SimpleReqHeader
        return this.http.post<any>(this.baseElasticSearchUrl + "/sponsorship_application_index/_search?size=100", valuationQuery, { headers: headers });
    }

    onQuerySearch(body: any) {
        let headers = this.createReqHeader();    //SimpleReqHeader
        return this.http.post<any>(this.baseElasticSearchUrl + "/sponsorship_application_index/" + "_search?size=100", body, { headers: headers });
    }

    onGetApplications() {
        let headers = this.createReqHeader();
        return this.http.get<any>(this.baseElasticSearchUrl + "/sponsorship_application_index/" + "_search?size=100", { headers: headers });
    }

    private createReqHeader() {
        let headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');
        headers.append('Access-Control-Allow-Origin', '*');
        return headers;
    }
}